<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="6">
          <b-form-group
              label="Transition Style:"
              description="Choose how you would like your files to transition from
              one to another"
          >
            <b-form-select
              id="match-groups"
              v-model="settingsUser.transition"
              :options="transitionStylesJSON"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
              label="Photo Display"
              description="Choose the style of the photo display."
          >
            <b-form-select
                id="photo-display"
                v-model="settingsUser.photoDisplay"
                :options="PhotoDisplay"
                @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
              label="Interval (sec):"
              description="How long photo shall wait before transitioning?"
          >
            <b-form-spinbutton
                id="match-size"
                v-model="settingsUser.interval"
                :min="intervalMin"
                :max="intervalMax"
                @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
              label="Backround playlist:"
              description="Choose the song you would like playing in the background."
          >
            <b-row>
              <b-col cols="1">
                <b-img
                    v-bind="iconImgProps"
                    rounded alt="Rounded image"
                />
              </b-col>
              <b-col cols="1">
                <item-store
                    :modal-id="modalSongStoreId"
                    store-title="Provided by PlayList"
                    btn-download-title="Add A Background song"
                    name="title"
                    asset-url-path="/assets/apps/playlist/"
                    :store-items="_pubStoreAudioItemsPlayList"
                    :user-owned-items="[]"
                    @selected-items="handleSelectedAudios"
                />
              </b-col>
               <b-col cols="10">
                <b-img
                    v-bind="mainPropAlbumCover"
                    v-for="(aSong, s) in settingsUser.bgSongs"
                    :src="`${assetsPathFromPlayList}${aSong.imgURL}`"
                    rounded
                    :alt="`${aSong.title} image`"
                    :key="`song_${s}`"
                    style="margin-right: 5px"
                />
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <h3>Add/View Photos</h3>
          <b-form-group
              label="Create A Memory"
              description="Create memories by adding and editing your photo"
          >
            <b-row>
            <b-col cols="1">
              <b-icon
                  icon="image"
                  animation="fade"
                  font-scale="2"
              />
            </b-col>
            <b-col cols="10">
              <item-add-image
                  :modal-id="modalImageAddId"
                  modal-title="Create a Memory"
                  btn-title="Done"
                  name="title"
                  :can-search="false"
                  @selected-items="handleImageItems"
              />
            </b-col>
          </b-row>
          </b-form-group>
          <b-form-group
              :description="
              `Click menu to see your current ${userDataPhotos.length} photos`
            "
          >
            <items-sidebar-settings
                :items="userDataPhotos"
                :assets-url-home="assetsURLHome"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import transitionStylesJSON from "../../assets/json/transitionStyles.json";
import ItemStore from "@/components/blockResources/_components/itemStore";
import ItemAddImage from "@/components/blockResources/_components/itemAddImage";
import ItemsSidebarSettings from "@/components/blockResources/_components/itemsSideBar";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
import PhotoDisplay from "../../assets/json/photoDisplay.json";
import _pubStoreAudioItemsPlayList from "@/assets/_appPublic/playList/assets/json/storeItemsSongs.json"
export default {
  name: "Settings_PhotoAlbum",
  components: {
    ItemStore,
    ItemAddImage,
    ItemsSidebarSettings
  },
  mixins: [ResourceBlockSettings],
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
    iconImgProps() {
      if (this.iconURLFromPlayList) {
        this.mainProps.src = this.iconURLFromPlayList;
      }
      return this.mainProps;
    },
    /* DATA */
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPlayList;
    },
    _pubStoreAudioItemsPlayList() {
      return  _pubStoreAudioItemsPlayList && _pubStoreAudioItemsPlayList.public &&
          Array.isArray(_pubStoreAudioItemsPlayList.public) &&
          _pubStoreAudioItemsPlayList.public[0].data &&
          Array.isArray(_pubStoreAudioItemsPlayList.public[0].data) ?
          _pubStoreAudioItemsPlayList.public[0].data :[];
    },
    assetsPathFromPlayList() {
      return  _pubStoreAudioItemsPlayList && _pubStoreAudioItemsPlayList.pathAssets?
          _pubStoreAudioItemsPlayList && _pubStoreAudioItemsPlayList.pathAssets:"";
    },
    iconURLFromPlayList() {
      return  _pubStoreAudioItemsPlayList && _pubStoreAudioItemsPlayList.urlIconImg?
          _pubStoreAudioItemsPlayList && _pubStoreAudioItemsPlayList.urlIconImg:"";
    },
  },
  methods: {
    handleImageItems(photos) {
      console.log(`These photos selected:${photos}`);
      let photoItems = {
        photos: photos
      };

      let notif = {//create message
        title: `${photos.length} Memories Added`,
        description: "Congrats you have updated your family memories",
        variant: "success"
      };
      const payload = {
        userData: photoItems,
        notif: notif,
        key: "photos"
      };
      this.handleUpdateUserData(payload);
    },
    handleShowPlayListClick() {
      //inside of sidebar?
      this.sidebarModel = false;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleSelectedAudios(selectedAudios){
      this.settingsUser.bgSongs=selectedAudios;
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 30,
        height: 30,
        class: "m1"
      },
      mainPropAlbumCover: {
        blank: false,
        blankColor: "#777",
        width: 50,
        height: 50,
        class: "m1"
      },
      modalSongStoreId:"playlist-store-id",
      PhotoDisplay,
      settingsUser: {
        bgSongs: this.settings && this.settings.user && this.settings.user.interval
            ? this.settings.user.bgSongs
            : [],
        interval:
          this.settings && this.settings.user && this.settings.user.interval
            ? this.settings.user.interval
            : 1,
        transition:
          this.settings && this.settings.user && this.settings.user.transition
            ? this.settings.user.transition
            : "fade",
        photoDisplay:
            this.settings && this.settings.user && this.settings.user.photoDisplay
                ? this.settings.user.photoDisplay
                : "full",
        _isRepeat:
          this.settings &&
          this.settings.user &&
          this.settings.user._isRepeat !== undefined
            ? this.settings.user._isRepeat
            : true,
        _isShuffle:
          this.settings &&
          this.settings.user &&
          this.settings.user._isShuffle !== undefined
            ? this.settings.user._isShuffle
            : false,
        _hideBottomBar:
            this.settings &&
            this.settings.user &&
            this.settings.user._hideBottomBar !== undefined
                ? this.settings.user._hideBottomBar
                : false,
        _autoPlayPhotoAudio:
            this.settings &&
            this.settings.user &&
            this.settings.user._autoPlayPhotoAudio !== undefined
                ? this.settings.user._autoPlayPhotoAudio
                : true,
        _autoPlayCreatedByAudio:
            this.settings &&
            this.settings.user &&
            this.settings.user._autoPlayCreatedByAudio !== undefined
                ? this.settings.user._autoPlayCreatedByAudio
                : true
      },
      assetsURLHome: "",
      transitionStylesJSON,
      _pubStoreAudioItemsPlayList,
      sidebarId: "settings-sidebar",
      sidebarModel: false,
      modalImageAddId: "photoadd",
      intervalMin: 2,
      intervalMax: 100,
      toggles: [
        {
          name: "Hide the bottom menu bar",
          description:
            "Hide the bottom bar for more presentation space.",
          property: "_hideBottomBar",
          type: "btns",
          text: "Hide the bottom bar for more presentation space.",
          isAvail: true,
          value: false
        },
        {
          name: "PlayPhotoAudio",
          description:
            "Automatically plays the audio recorded for photo on transition",
          property: "_autoPlayPhotoAudio",
          type: "btns",
          text: "Auto-play photo audio",
          isAvail: true,
          value: true
        },
        {name: "PlayFamilyAudio",
          description:
              "Auto-plays the audio for the family member who added the photo",
          property: "_autoPlayCreatedByAudio",
          type: "btns",
          text: "Auto-play family audio",
          isAvail: true,
          value: true
        },
        {
          name: "Repeat",
          description: "Keep the memories playing endlessly.",
          property: "_isRepeat",
          type: "btns",
          text: "Keep the memories playing endlessly.",
          isAvail: true,
          value: false
        },
        {
          name: "Shuffle",
          description: "Mix up your photos",
          property: "_isShuffle",
          type: "btns",
          text: "Enable shuffle mode to mix up your photos",
          isAvail: true,
          value: true
        },
        {
          name: "Added by Family",
          description: "Enable to display the family who added the photo",
          property: "_addedBys",
          type: "btns",
          text: "Show added by family",
          isAvail: true,
          value: true
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
